import { BaseApi } from "@/api/BaseApi";
import Config from "@/const/Config";
import { HayabanOsoban, HayabanOsobanDetail } from '@/types/Shinsei'
export class HayabanOsobanApi extends BaseApi {

  /**
   * 早番遅番申請を登録します
   * @returns
   */
  public async createShinsei(req: HayabanOsoban): Promise<any> {
    try {
      return await this.post<HayabanOsoban>(Config.API_URL + "/shinsei/no_approval/hayaban_osoban/", req);
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 早番遅番申請を削除します
   * @returns
   */
  public async deleteShinsei(hayabanOsoban: HayabanOsoban, koyouKeiyakuTimeId: number): Promise<any> {
    try {
      const req = {
        hayabanOsoban,
        koyouKeiyakuTimeId
      }
      return await this.delete(Config.API_URL + "/shinsei/no_approval/hayaban_osoban/", req);
    } catch (e: unknown) {
      throw e;
    }
  }
  
  /**
   * 早番遅番申請の詳細を取得します
   * @returns
   */
  public async getDetail(id: number): Promise<HayabanOsobanDetail> {
    try {
      const req = {
        id
      }
      const res = await this.post<HayabanOsobanDetail>(Config.API_URL + "/shinsei/no_approval/hayaban_osoban/detail/", req);
      return res.data
    } catch (e: unknown) {
      throw e;
    }
  }
}
